import {
  Alert,
  AlertDescription,
} from "@babackapp/customer-ui/components/alert";
import { InfoIcon } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { TextDto } from "@babackapp/private-api-client";
import {
  compilePortalTemplate,
  type PortalTemplateContext,
} from "../lib/portal-template.lib";
import { pickLocalizedText } from "../utils/pick-localized-text";

type Props = {
  texts?: TextDto[] | null;
} & PortalTemplateContext;

export function UserPortalCallout({
  texts,
  returnRequest,
  availableItems,
}: Props) {
  const { i18n } = useTranslation("return-widget-v3");
  const text = texts?.length
    ? pickLocalizedText(texts, i18n.language ?? "en")
    : null;
  const html = useMemo(
    () =>
      text && compilePortalTemplate(text, { returnRequest, availableItems }),
    [text, returnRequest, availableItems],
  );

  if (!html) return null;

  return (
    <Alert variant="default">
      <InfoIcon />
      <AlertDescription dangerouslySetInnerHTML={{ __html: html }} />
    </Alert>
  );
}
